import React, { useState } from 'react';
import {
  IconColumn,
  IconFilter,
  IconPen,
  IconTrash,
  IconPlus,
} from '../../../common/icons';
import Pagination from '../../../common/pagination';
import EquipmentTab from '../EquipmentTabs';
import ChassisLoadPage from './chassisLoadPage';
import ChassisLoadSubHeader from './chassisLoadSubHeader';
const cardItems = [
  {
    id: 1,
    count: 540,
    title: 'Available',
  },
  {
    id: 2,
    count: 703,
    title: 'Dispatched',
  },
  {
    id: 3,
    count: 740,
    title: 'Loaded',
  },
  {
    id: 4,
    count: 994,
    title: 'Empty',
  },
];

const tableHeaderData = [
  'Truck',
  'Fleet owner',
  'License ',
  'VIN',
  'Address',
  'AID',
  'ITD',
  'Registration',
  'Inspection',
  'HUT',
  'Annual insp.',
  'Annual insp.',
  'Bobtail Insur.',
  'Diesel Emission',
  'IFTA',
];
const tableData = [];
for (let i = 0; i < 20; i++) {
  tableData.push({
    id: i,
    truck: 'truck sdasdas',
    fleetOwner: 'DB Trucks',
    license: 'FL523652365',
    licensetype: 'FL',
    vin: '12478723471471478',
    address: '2715 Ash Dr. San Jose, South Dakota 83475',
    aid: '06/11/21',
    itd: '06/11/21',
    registration: '06/11/21',
    inspection: '06/11/21',
    hut: '06/11/21',
    annualInsp: '06/11/21',
    annualInspe: '06/11/21',
    bobtailInsur: '06/11/21',
    dieselEmission: '06/11/21',
    ifta: '06/11/21',
  });
}

const TruckProfiles = () => {
  const [isCardActive, setCardActive] = useState(1);
  const [ChassisLoad, setChassisLoad] = useState(false);
  const handleShowChassisLoad = (event) => {
    setChassisLoad(true);
  };

  const handleHideChassisLoad = (event) => {
    setChassisLoad(false);
  };

  return (
    <div className="position-relative subheader-wrapper">
      {!ChassisLoad ? (
        <React.Fragment>
          <div className="subheader">
            <div className="subheader__inner d-flex align-items-center py-0">
              <EquipmentTab
                activeTab={1}
                button={
                  <div className="d-flex">
                    <button className="ml-auto btn btn-success">
                      <IconPlus className="mr-2" />
                      Add New Truck
                    </button>
                  </div>
                }
              />
            </div>
          </div>
          <div className="page-fluid">
            <div className="top-page">
              <div className="pb-15 d-flex align-items-center">
                <div className="d-flex align-items-center">
                  <h4 className="font-20 mb-0">Drivers</h4>
                </div>
                {/* Pagination  */}
                <Pagination className="ml-auto" />
              </div>
              {/* Cards Row */}
              <div className={`form-row ${isCardActive ? 'hasactive' : ''}`}>
                {cardItems.map((cardItem) => (
                  <div className="col-md my-2">
                    <div
                      className={`ncard d-flex flex-column justify-content-between p-10 ${
                        isCardActive === cardItem.id ? 'active' : ''
                      }`}
                      onClick={() => setCardActive(cardItem.id)}
                    >
                      <div className="d-flex align-items-center">
                        <div className="mr-1 sbox sbox--default px-2 h-100">
                          {cardItem.count}
                        </div>
                        <div>{cardItem.title}</div>
                        <div className="ml-auto">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={
                                isCardActive === cardItem.id ? 'true ' : null
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Filter Row */}
              <div className="filter-row d-flex align-items-center">
                <div className="app-search header-search">
                  <span className="search-icon"> </span>
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control input-search-left"
                      placeholder="Search..."
                      value=""
                    />
                  </div>
                </div>
                <div className="d-flex">
                  <div className="form-check form-check--gray pr-30">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="Available"
                    />
                    <label className="form-check-label" for="Available">
                      Enabled
                      <span className="badge badge-gray-100 font-12 ml-2 badge-pill">
                        47
                      </span>
                    </label>
                  </div>
                  <div className="form-check form-check--gray pr-30">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="Pending"
                    />
                    <label className="form-check-label" for="Pending">
                      Disabled
                      <span className="badge badge-gray-100 font-12 ml-2 badge-pill">
                        6
                      </span>
                    </label>
                  </div>
                </div>
                <div className="ml-auto d-flex">
                  <div className="position-relative">
                    <button className="btn btn-outline-light position-relative">
                      <IconColumn />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Table */}
            <div
              className="table-responsive"
              style={{ height: 'calc(100vh - 319px)' }}
            >
              <table className="table table-card table-card--ls">
                <thead>
                  <tr>
                    {tableHeaderData.map((headetItem) => {
                      return (
                        <th scope="col" key={headetItem}>
                          {headetItem}
                        </th>
                      );
                    })}
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((tdata) => {
                    return (
                      <tr key={tdata.id}>
                        <td>{tdata.truck}</td>
                        <td>{tdata.fleetOwner}</td>
                        <td>
                          <div>{tdata.license}</div>
                          <div className="text-muted">{tdata.licensetype}</div>
                        </td>
                        <td>{tdata.vin}</td>
                        <td width="10%">{tdata.address}</td>
                        <td className="bg-warning-500">{tdata.aid}</td>
                        <td className="bg-warning-500">{tdata.itd}</td>
                        <td className="bg-warning-50">{tdata.registration}</td>
                        <td className="bg-warning-50">{tdata.inspection}</td>
                        <td className="bg-warning-50">{tdata.hut}</td>
                        <td className="bg-warning-50">{tdata.annualInsp}</td>
                        <td className="bg-warning-50">
                          <div>{tdata.annualInspe}</div>
                        </td>
                        <td className="bg-warning-50">
                          <div className="text-muted">{tdata.bobtailInsur}</div>
                        </td>
                        <td className="bg-warning-50">
                          {tdata.dieselEmission}
                        </td>
                        <td className="bg-warning-50">{tdata.ifta}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <button className="btn btn-link">
                              <a href="#" onClick={handleShowChassisLoad}>
                                <IconPen className="text-muted" />
                              </a>
                            </button>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <button className="btn btn-link">
                              <IconTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <ChassisLoadSubHeader closeChassisLoad={handleHideChassisLoad} />
          <ChassisLoadPage />
        </React.Fragment>
      )}
    </div>
  );
};

export default TruckProfiles;
